import { get } from 'lodash';
import store from '../store/index';
import i18n from '../vue-i18n';

const getFormattedDate = (translationKey, date) => {
    const separator = get(store.state, 'clientConfig.i18nConfig.defaultDateSeparator');
    const dateFormat = i18n.t(translationKey, { separator });
    return i18n.d(dateFormat, date);
};

const getFormattedWeekNumber = (prefix, week) => {
    return i18n.t(prefix).concat(String(week).padStart(2, '0'));
};

const getWeekNumberClient = week => {
    return getFormattedWeekNumber('general.dates.weekFirstLetter', week);
};

const getWeekNumberShorthandClient = (translationKey, week) => {
    return getFormattedWeekNumber('general.dates.weekShorthand', week);
};

const datesInYear = (date, moment) => {
    return i18n.eUTC('dates.default.datesInYear', date, moment);
};

const utils = {
    weekNumberShorthand: i18n.eUTC,
    weekNumberShorthandClient: getWeekNumberShorthandClient,
    weekNumber: i18n.eUTC,
    weekNumberClient: getWeekNumberClient,
    dateShorthand: i18n.eUTC,
    dateShorthandNoYear: i18n.eUTC,
    dateTime: i18n.d,
    localShortDate: i18n.d,
    localDayMonth: getFormattedDate,
    fullDateText: i18n.d,
    datepickerFormat: i18n.eUTC,
    datesInYear,
    timeStamp: i18n.d,
};

export default utils;
